import Vue from 'vue'
import Http from "@/plugins/http.plugin"
import VuetifyMask from "vuetify-mask"

Vue.use(VuetifyMask);
Vue.use(Http)
